
import Vue from "vue";
import { Component } from "vue-property-decorator";
import * as ST from "@/components/controls/s-table/exports";
import STable from "@/components/controls/s-table/sTable.vue";
import TextEdit from "@/components/controls/text-edit.vue";
import { IsNewRow } from "@/components/controls/s-table/exports";
import { restaurantApi } from "@/services/RApiService";
import { ProductDetail } from "@/api/restaurant";

@Component({
  components: {
    STable,
  },
})
export default class RProductDetails extends Vue {
  dataSource: ProductDetail[] = [];

  tableSettings: ST.Settings<ProductDetail> = {
    dataSource: this.dataSource,
    pagination: false,
    showNewRow: true,
    newRowText: "Ny produktegenskap",
    newRowInit: () => ({}),
    recordsUpdated: async (records) => this.postRecord(records),
    loading: false,
    actions: {
      remove: {
        icon: "delete",
        confirmation: (record) =>
          `Är du säker på att du vill ta bort ${record.value}`,
        action: (record) => {
          this.deleteRecord(record);
        },
      },
    },
    columns: [
      {
        title: "Egenskap",
        width: 400,
        edit: TextEdit,
        editData: (record) => ({
          editable: true,
          editValue: record.value,
          dataBinding: {
            propertyName: "value",
          },
          updateEmitter: "valueChanged",
          props: {
            defaultOpen: !IsNewRow(record),
            defaultValue: record.value,
            placeHolder: "Egenskap",
          },
        }),
      },
    ],
  };

  async mounted() {
    var result = await restaurantApi.getProductDetails();
    this.dataSource.push(...result.data);
  }
  async deleteRecord(record: ProductDetail) {
    console.log(record);
    await restaurantApi.deleteProductDetail(record.id);
    var recordIndex = this.dataSource.indexOf(record, 0);
    if (recordIndex > -1) this.dataSource.splice(recordIndex, 1);
    this.notify("Egenskapen har blivit borttagen", record.value ?? "");
  }
  async postRecord(records: ProductDetail[]) {
    for (const record of records) {
      var res = await restaurantApi.postProductDetail(record);
      record.id = res.data.id;
    }
    this.notify("Ändringarna har blivit sparade", "Sparat");
  }
  public notify(description: string, message: string) {
    this.$notification.open({
      message: message,
      description: description,
      placement: "bottomRight",
      duration: 4,
    });
  }
}
